import React, { Component } from 'react';
import api from '../api';
import { NotificationSignOut } from '../components';

export default class NotificationSignOutContainer extends Component {

    state = {
        isSigningOut: true,
        mailName: '',
        email: ''
    }

    componentDidMount() {
        const { token, mailName } = this.props.params;
        const email = this.props.location.query.email
        api.notificationSignOut(token, mailName, email).finally(() => {
            this.setState({
                isSigningOut: false,
                mailName: mailName,
                email: email
            });
        });
    }

    render() {
        return (
            <NotificationSignOut isSigningOut={this.state.isSigningOut} mailName={this.state.mailName} />
        );
    }
}



// WEBPACK FOOTER //
// ./src/features/signout-notifications/containers/NotificationSignOutContainer.js